import React from "react";

import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import {
  SUPPLIERS_URL,
  DELETE_SUPPLIER,
  SAVE_SUPPLIER,
} from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import ItemValidationSchema from "@Utils/Validations/ItemValidationSchema";

function SuppliersListing() {
  const attributes = [{ key: "supplierName", label: "Supplier Name", flex: 2 }];

  const validationSchema = ItemValidationSchema(attributes[0].key,attributes[0].label);
  return (
    <GenericItemsListing
      items_URL={SUPPLIERS_URL}
      SAVE_Item={SAVE_SUPPLIER}
      DELETE_Item={DELETE_SUPPLIER}
      title="Suppliers"
      name="Supplier"
      icon={<Inventory2RoundedIcon fontSize="large" color="white" />}
      attributes={attributes}
      validationSchema={validationSchema}
        uniqueId={"supplierId"}
    />
  );
}

export default SuppliersListing;
